import { find, reverse } from 'lodash';
import React, { useContext, useMemo } from 'react';
import { useQuery } from 'react-query';
import { Breadcrumb, Loader } from 'rsuite';
import { fetchCategoriesList } from '../api';
import { useLocation } from '../hooks/useLocation';
import { doHref } from '../utils/doHref';
import { EquipmentContext } from '../utils/scope';

export const Bread = () => {
  // const { category: categoryProp } = props;
  const scope = useContext(EquipmentContext);
  const { status, data } = useQuery([scope, 'categories'], fetchCategoriesList);

  const {
    params: { category },
  } = useLocation();

  const parents = useMemo(() => {
    if (!data) {
      return [];
    }
    if (!category) {
      return [];
    }

    let i = 0;
    const root_id = data.root_id;
    const catItem = find(data.items, { slug: category });
    if (!catItem) {
      return [];
    }

    const parents = [catItem];
    let current_id = catItem.parent;

    while (i < 20 && root_id !== current_id) {
      i++;
      const parent = find(data.items, { term_id: current_id });
      if (parent) {
        current_id = parent.parent;
        parents.push(parent);
      } else {
        break;
      }
    }

    return reverse(parents);
  }, [data, category]);

  let text = 'All Listings';
  if (scope === 'parts') {
    text = 'All Parts';
  }

  if (status === 'loading') {
    return (
      <Breadcrumb separator={'>'}>
        <Breadcrumb.Item href={doHref()}>{text}</Breadcrumb.Item>
        <Loader size="xs" />
      </Breadcrumb>
    );
  }

  return (
    <Breadcrumb separator={'>'}>
      <Breadcrumb.Item href={doHref()}>{text}</Breadcrumb.Item>
      {parents.map(({ term_id, name, slug }) => {
        return (
          <Breadcrumb.Item
            key={term_id}
            href={doHref({ category: slug })}
            dangerouslySetInnerHTML={{ __html: name }}
          />
        );
      })}
    </Breadcrumb>
  );
};
